import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { primaryDark } from "../../Constants/Colors";

const height = 300;
const width = 300;

const SmallCard = ({
  icon,
  title,
  description,
  buttonText = "LEARN",
  onButtonPress,
  iconBackgroundColor = "#E3D8FF",
  iconColor = "#7C3AED",
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <View style={[styles.wrapper, isHovered && { zIndex: 9999 }]} className="small-card-wrapper">
      {/* Main white card */}
      <TouchableOpacity
        style={[styles.card, isHovered ? styles.cardHovered : { height: "100%" }]}
        onMouseEnter={() => {
          setIsHovered(true);
        }}
        onMouseLeave={() => {
          setIsHovered(false);
        }}
      >
        {/* Icon circle */}

        <View
          style={{
            flex: 1,
            overflow: "hidden",
            alignItems: "center",
            marginBottom: isHovered ? 0 : 20,
          }}
        >
          {/* {highlightedIndex && highlightedIndex !== index && (
            <View
              style={{
                position: "absolute",
                zIndex: 9999,
                width: "100%",
                height: "100%",
                borderRadius: 10,
                backgroundColor: "#fcfcfc83",
              }}
            />
          )} */}
          <View style={[styles.iconContainer, { backgroundColor: iconBackgroundColor }]}>
            <View style={styles.defaultIcon}>
              <Text style={[styles.iconText, { color: iconColor }]}>{icon}</Text>
            </View>
          </View>

          {/* Title */}
          <Text style={styles.title}>{title}</Text>

          {/* Description with **bold** parts */}

          <Text style={styles.description}>
            {description.split("**").map((part, index) =>
              index % 2 === 1 ? (
                <Text key={index} style={styles.bold}>
                  {part}
                </Text>
              ) : (
                <Text key={index}>{part}</Text>
              )
            )}
          </Text>
          {!isHovered && (
            <View
              style={{
                height: 60,
                position: "absolute",
                background:
                  "linear-gradient(to bottom, rgba(255, 255, 255, 0.32), rgba(255, 255, 255, 1))",
                bottom: 0,
                left: 0,
                right: 0,
              }}
            />
          )}
        </View>

        {/* Floating LEARN button — hidden when the card is expanded */}
        {!isHovered && (
          <TouchableOpacity
            activeOpacity={0.85}
            style={styles.learnButton}
            className="small-card-button"
            onPress={onButtonPress}
          >
            <Text style={styles.learnButtonText}>{buttonText}</Text>
          </TouchableOpacity>
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  // Wrapper so we can add outer glow via CSS and place button overlapping
  wrapper: {
    alignItems: "center",
    justifyContent: "flex-start",
    margin: 16,

    // paddingBottom: 32, // space for button shadow
    // backgroundColor: "red",
    maxWidth: width,
    height: height,
    marginBottom: 60,
    alignSelf: "center",
  },

  card: {
    width: "100%",

    backgroundColor: "#FFFFFF",
    borderRadius: 15,
    paddingHorizontal: 30,
    paddingTop: 25,
    // paddingBottom: 56, // give room above button
    alignItems: "center",

    // paddingBottom: 56,

    // subtle internal shadow (mobile / native)
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 30,
    elevation: 3,

    // smooth transition
    transition: "all 0.5s ease-in-out",
  },

  cardHovered: {
    // stronger shadow on hover (web)
    // position: "absolute",
    borderColor: primaryDark,
    borderWidth: 2,
    shadowColor: primaryDark,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.6,
    shadowRadius: 60,
    elevation: 666,
    paddingBottom: 25,
  },

  iconContainer: {
    width: 96,
    height: 96,
    borderRadius: 48,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  defaultIcon: {
    alignItems: "center",
    justifyContent: "center",
  },
  iconText: {
    fontSize: 44,
  },

  title: {
    fontSize: 20,
    fontWeight: "700",
    color: "#111827",
    textAlign: "center",
    marginBottom: 18,
    lineHeight: 28,
  },

  description: {
    fontSize: 14,
    color: "#9CA3AF",
    textAlign: "center",
    lineHeight: 22,
  },

  bold: {
    fontWeight: "700",
    color: "#6B7280",
  },

  // Floating LEARN button
  learnButton: {
    position: "absolute",
    bottom: -5,
    transform: [{ translateY: 18 }], // push it a bit outside card bottom
    backgroundColor: "#FFFFFF",
    paddingVertical: 14,
    paddingHorizontal: 48,
    borderRadius: 999,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.1,
    shadowRadius: 20,
    elevation: 5,
  },
  learnButtonText: {
    fontSize: 14,
    fontWeight: "700",
    letterSpacing: 6,
    color: "#9CA3AF",
  },
});

export default SmallCard;
